// Shim for react-native-config in web environment
// libs/api/config.ts imports this for default API_URL — will be overridden by configureApi()
const Config: Record<string, string | undefined> = {};

export default Config;
